export interface NumberRangeDescription {
  id: number;
  language_code: string;
  display_name: string;
  description?: string | null;

  // GenericForeignKey fields
  content_type: string; // "numberrangebasefunction" oder "numberrangesubfunction"
  object_id: number;    // ID der Base/Sub Function
}

export interface NumberRangeBaseFunction {
  id: number;
  digit: number;
  /** 0–100 overlay on AGV preview; null = client fallback band */
  chip_top?: number | null;
  chip_left?: number | null;
  /** If false, this base is hidden as a chip on the AGV (admin + creator). Default true when omitted. */
  show_on_agv?: boolean;

  descriptions?: NumberRangeDescription[];
}

/** Configured label (preferred language, then any language). Empty if no display_name is set. */
export function numberRangeDisplayName(
  descriptions: NumberRangeDescription[] | undefined,
  preferredLanguage = "eng"
): string {
  const list = descriptions ?? [];
  const preferred = list.find((d) => d.language_code === preferredLanguage)?.display_name?.trim();
  if (preferred) return preferred;
  const any = list.map((d) => (d.display_name ?? "").trim()).find(Boolean);
  return any ?? "";
}

/** Prefer `description` text (e.g. English) for chip tooltips; falls back to any language, then display name. */
export function descriptionTooltipText(
  descriptions: NumberRangeDescription[] | undefined,
  preferredLanguage = "eng"
): string {
  const list = descriptions ?? [];
  const bodyPreferred = list.find((d) => d.language_code === preferredLanguage)?.description?.trim();
  if (bodyPreferred) return bodyPreferred;
  for (const d of list) {
    const t = (d.description ?? "").trim();
    if (t) return t;
  }
  const name = list.find((d) => d.language_code === preferredLanguage)?.display_name?.trim();
  if (name) return name;
  const anyName = list.map((d) => (d.display_name ?? "").trim()).find(Boolean);
  return anyName ?? "";
}

/** Same language preference as tooltips, but only the `description` field (no display_name fallback). */
export function descriptionBodyText(
  descriptions: NumberRangeDescription[] | undefined,
  preferredLanguage = "eng"
): string {
  const list = descriptions ?? [];
  const bodyPreferred = list.find((d) => d.language_code === preferredLanguage)?.description?.trim();
  if (bodyPreferred) return bodyPreferred;
  for (const d of list) {
    const t = (d.description ?? "").trim();
    if (t) return t;
  }
  return "";
}

export interface NumberRangeSubFunction {
  id: number;
  base: number; // id einer NumberRangeBaseFunction
  digit: number;
  chip_top?: number | null;
  chip_left?: number | null;

  descriptions?: NumberRangeDescription[];
}
